import * as cmsPagesHelpers from './gettersCmsPageHelpers'
import * as internalRoutingHelpers from './gettersInternalRoutingHelpers'

export const gettersCmsPagesHelper = Object.assign({}, ...Object.values(cmsPagesHelpers))
export const gettersInternalRoutingHelpers = Object.assign({}, ...Object.values(internalRoutingHelpers))

export { default as gettersMobileRoutingHelpers } from './gettersMobileRoutingHelpers'
